import React from 'react';
import { Card } from 'react-bootstrap';
import { FaInbox } from 'react-icons/fa';

// W-0928 — Empty state pattern (ADR-009 + Q-07 híbrido).
// Renderizado quando `Itens.length === 0`. Substitui modal informativo do ERP.
const EmptyState = ({
  mensagem = 'Nenhum registro encontrado para os filtros aplicados',
}) => (
  <Card className="mb-0">
    <Card.Body className="py-5" style={{ minHeight: 180 }}>
      <div className="text-center">
        <FaInbox size={48} className="text-secondary mb-3" />
        <h5 className="text-secondary">Sem resultados</h5>
        <p className="text-muted mb-0">{mensagem}</p>
      </div>
    </Card.Body>
  </Card>
);

export default EmptyState;
